import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { Icon, InfoIcon } from 'components/shared/Icon/Icon'

import styles from './NoteCard.module.scss'

export const NoteCard = ({ className, icon = InfoIcon, text, title }) => (
  <Box
    className={cx(styles.card, { [className]: Boolean(className) })}
    direction="column"
    justify="center"
  >
    <Box align="center">
      <Icon className={styles.icon} size={16} {...{ icon }} />
      <p className={styles.title}>{title}</p>
    </Box>
    <p className={styles.text}>{text}</p>
  </Box>
)
